import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { NavigationLink } from "@/lib/types";
import {
  ChartPieSlice,
  CalendarDot,
  DotsThreeCircle,
  Scales,
  Wallet,
} from "@phosphor-icons/react";

export const initialLinks: NavigationLink[] = [
  {
    order: 1,
    label: "navigation.home",
    icon: CalendarDot,
    path: "/",
  },
  {
    order: 2,
    label: "navigation.balance",
    icon: Scales,
    path: "/balance",
  },
  {
    order: 3,
    label: "navigation.invoices",
    icon: Wallet,
    path: "/invoices",
  },
  {
    order: 4,
    label: "navigation.reports",
    icon: ChartPieSlice,
    path: "/reports",
  },
  {
    order: 5,
    label: "navigation.more",
    icon: DotsThreeCircle,
    path: "/more",
  },
];

type NavigationStore = {
  links: NavigationLink[];
  setLinks: (links: NavigationLink[]) => void;
  addLink: (link: NavigationLink) => void;
  removeLink: (path: string) => void;
  updateByOrder: (order: number, link: Partial<NavigationLink>) => void;
};

const useNavigationStore = create<NavigationStore>()(
  devtools(
    (set) => ({
      links: initialLinks,
      setLinks: (links: NavigationLink[]) => set({ links }),
      addLink: (link: NavigationLink) => {
        set((state) => ({
          links: [...state.links, link],
        }));
      },
      removeLink: (path: string) => {
        set((state) => ({
          links: state.links.filter((l) => l.path !== path),
        }));
      },
      updateByOrder: (order: number, link: Partial<NavigationLink>) => {
        set((state) => ({
          links: state.links.map((l) =>
            l.order === order ? { ...l, ...link } : l
          ),
        }));
      },
    }),
    { name: "navigation" }
  )
);

export default useNavigationStore;
